import { Component, ChangeDetectionStrategy, Output, EventEmitter, Input, OnInit, inject } from '@angular/core';
import { TranslateDirective, TranslatePipe } from '@ngx-translate/core';

import { WindowService } from '@modules/shared/services/window.service';

import { BaseModalComponent } from '../../base-modal/base-modal.component';

@Component({
  selector: 'mb-ics-modal',
  templateUrl: './ics-modal.component.html',
  styleUrls: ['./ics-modal.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [BaseModalComponent, TranslateDirective, TranslatePipe],
})
export class IcsModalComponent implements OnInit {
  private windowService = inject(WindowService);

  public isMobile = false;
  @Input() icsLink!: string;

  @Output() confirm = new EventEmitter<{ remember: boolean }>();
  @Output() requestCancel = new EventEmitter();

  ngOnInit() {
    this.isMobile = this.windowService.isMobileBrowser;
  }
}
